import { FC, memo } from 'react';
import { Box, SystemStyleObject } from '@chakra-ui/react';

import { childrenExceptTypeEdge } from '~/core/shared/utils/styles';
import { BlocksRenderer } from '../BlocksRenderer';
import { FormRepeaterActionButtons } from '../FormRepeaterActionButtons';
import { FormRepeaterRemoveButton } from '../FormRepeaterRemoveButton';
import { AdditionalValuesCardProps } from './types/AdditionalValuesCardProps';

// TODO: @haxxxton - find a way to avoid needing to do this.. likely with Stack
const cssStyles: Record<string, SystemStyleObject> = {
  [childrenExceptTypeEdge('first')]: {
    pt: 4,
  },
  [childrenExceptTypeEdge('last')]: {
    pb: 4,
  },
};

const AdditionalValuesCardComponent: FC<AdditionalValuesCardProps> = ({
  formBlocks,
  namePrefixes,
  onRemove,
}) => (
  <Box pb={6} position="relative" pt={10}>
    <FormRepeaterActionButtons>
      <FormRepeaterRemoveButton onRemove={onRemove} />
    </FormRepeaterActionButtons>

    <Box css={cssStyles}>
      <BlocksRenderer blocks={formBlocks} namePrefixes={namePrefixes} />
    </Box>
  </Box>
);

export const AdditionalValuesCard = memo(AdditionalValuesCardComponent);
